import { Appointment } from "@elixir/types";
import { notification } from "antd";
import { useState } from "react";
import { ReactComponent as GSolidIcon } from "../../../../assets/icons/font-awesome/g-solid.svg";
import {
  isGoogleReviewLinkSetup,
  showGoogleReviewDialog,
} from "../../../../utils/bridges/methods";
import { sendBusinessGoogleReviewLink } from "apis";
import { ChipWithTooltip } from "ui";

const SendGoogleReviewLinkButton = ({
  apt,
  className = "",
  type,
}: {
  apt: Appointment;
  className?: string;
  type?: "primary" | "secondary";
}) => {
  const [reviewLinkSend, setGoogleReviewLinkSent] = useState(false);
  const handleReviewLinkSend = async () => {
    const isGoogleReviewLinkSetupFlag = isGoogleReviewLinkSetup(apt.doctor_oid);
    if (!isGoogleReviewLinkSetupFlag) {
      showGoogleReviewDialog({ docId: apt.doctor_oid });
      return;
    }
    const response = await sendBusinessGoogleReviewLink({
      aid: apt.aid,
    });

    if (response.success) {
      notification.success({
        message: "Google Review Link Sent",
        description: `Google review link has been sent to ${apt.patient.fln}.`,
        placement: "bottomRight",
      });
      setGoogleReviewLinkSent(true);
    } else {
      notification.error({
        message: "Error in sending google review link",
        description: response.error || "Something went wrong.",
        placement: "bottomRight",
      });
      setGoogleReviewLinkSent(false);
    }
  };
  return (
    <ChipWithTooltip
      selected={reviewLinkSend}
      onClick={handleReviewLinkSend}
      className={`h-32 flex-1 ${className}`}
      icon={<GSolidIcon className="dr-min-w-14 dr-h-14" />}
      title="Review"
      tooltipText="Send Google Review Link"
      type={type}
    />
  );
};

export default SendGoogleReviewLinkButton;
